module.exports = __webpack_public_path__ + "img/tag_ticket.a28cbb44.png";